"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API = void 0;
const helpers_1 = require("@/app/shared/helpers");
const generated_api_1 = require("./generated-api");
const token_1 = require("./token");
exports.API = new generated_api_1.Api();
exports.API.instance.interceptors.request.use(async (request) => {
    try {
        await (0, token_1.ensureValidSalesForceToken)();
        const token = helpers_1.Storage.Local.get(helpers_1.Storage.Key.SERVER_SALESFORCE_ACCESS_TOKEN);
        const instanceUrl = helpers_1.Storage.Local.get(helpers_1.Storage.Key.SERVER_SALESFORCE_INSTANCE_URL);
        const serverPrefix = helpers_1.Storage.Local.get(helpers_1.Storage.Key.SERVER_PREFIX);
        const serverPrefixPath = serverPrefix ? `/${serverPrefix}` : '';
        if (!instanceUrl)
            throw new Error('Instance URL is not set!');
        if (!token)
            throw new Error('Access token is not set!');
        request.baseURL = (0, helpers_1.buildSalesForceInstanceUrl)(instanceUrl, '/services/apexrest' + serverPrefixPath);
        request.headers.set('authorization', `Bearer ${token}`);
        request.headers.set('language', 'en');
        return request;
    }
    catch (error) {
        console.error('Request interceptor failed:', error);
        return Promise.reject(error);
    }
}, (error) => {
    return Promise.reject(error);
});
